import { combineReducers } from 'redux';

import maxesGoalsUiReducer from './maxesGoalsUiReducer';
import maxesGoalsDataReducer from './maxesGoalsDataReducer';

export default combineReducers({
  ui: maxesGoalsUiReducer,
  data: maxesGoalsDataReducer,
});
